import React, { useState, useEffect } from 'react'
import useModal from 'hook/useModal'

// css
import 'assets/style/elements/taglist.scss'

// components
import IconButton from 'components/elements/IconButton'
import Tag from 'components/elements/Tag'
import Image from 'components/elements/Image'
import Text from 'components/elements/Text'

function Element({ className, tags }) {
  return <div className="tag-list">{tags}</div>
}

export default Element
